import "./modules/switch-theme";
import "./modules/middlewares/goToPayment.middleware";
import "./modules/lazy-images";
import "./modules/sliders/sliders";
import "./modules/forms/forms";
import "./modules/forms/payment-form/payment-form";
import "./modules/forms/payment-form/range-input";
import "./modules/forms/payment-form/provider-choice";
import "./modules/forms/payment-form/get-promocode";
import "./modules/forms/payment-form/tcs-credit";
import "./modules/forms/testdrive-form/testdrive-form";
import "./modules/modal";
// import "./modules/masks/tel";
import "./modules/masks/telegram";
import "./modules/accordion";
import "./modules/burger";
import "./modules/showmore";
import "./modules/smoothScrollToAnchor";
import "./modules/header";
import "./modules/marquee";
import "./modules/price-type-toggle";
import "./modules/popup-hint";
import "./modules/play-button";
import "./modules/fancyboxes";
import "./modules/loadmore";
import "./modules/connect";
import "./modules/dynamic-inviting";
import "./modules/fail-page";
import "./modules/discount-popup";
import "./modules/save-query-param";
// import "./snow";
